var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 17.8867L4.45801 17.0117L8.54134 12.9284C8.87467 12.5951 9.0969 12.2895 9.20801 12.0117C9.31912 11.7339 9.37467 11.3242 9.37467 10.7826V5.26172L7.49967 7.13672L6.62467 6.26172L9.99967 2.88672L13.3747 6.26172L12.4997 7.13672L10.6247 5.26172V10.7826C10.6247 11.3242 10.6802 11.7339 10.7913 12.0117C10.9025 12.2895 11.1247 12.5951 11.458 12.9284L15.5413 17.0117L14.6663 17.8867L9.99967 13.2201L5.33301 17.8867Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorIcon);
export default __webpack_public_path__ + "static/media/vectorIcon.bcd423103d85b04274cf0e499c02f26b.svg";
export { ForwardRef as ReactComponent };